/** @format */
import DefaultImg from '../../Assets/Images/default.png';

const SignatureFields = ({
	onChangeValue,
	fileSignature,
	onSignatureSelect,
	signatureImage,
	fieldChange,
}) => {
	return (
		<div className='col-12 border my-2'>
			<div className='form-group '>
				<div className='d-flex flex-column mt-1 mx-2'>
					<label>امضاء</label>
					<input
						type='file'
						className='d-none'
						ref={fileSignature}
						id={`signature-image`}
						onChange={() => onSignatureSelect()}
					/>
					<img
						onClick={() => {
							let input = document.getElementById(`signature-image`);
							input.click();
						}}
						className='bg-white img-thumbnail c-pointer'
						style={{ width: '100px', height: '100px' }}
						src={
							signatureImage !== undefined && signatureImage.length > 0
								? signatureImage
								: DefaultImg
						}
						alt='im'
					/>
				</div>
				<div className='d-flex flex-row justify-content-around'>
					<div className='form-group mt-2 w-100 mx-1'>
						<label>عنوان امضا</label>
						<input
							className='form-control my-2'
							onChange={(e) =>
								onChangeValue(
									'title',
									e.target.value,
									fieldChange.signature,
									null,
									null,
								)
							}
						/>
					</div>
					<div className='form-group mt-2 w-100 mx-1'>
						<label>عرض امضاء</label>
						<input
							className='form-control my-2'
							onChange={(e) =>
								onChangeValue(
									'width',
									e.target.value,
									fieldChange.signature,
									null,
									null,
								)
							}
						/>
					</div>
					<div className='form-group mt-2 w-100 mx-1'>
						<label>ارتفاع امضاء</label>
						<input
							className='form-control my-2'
							onChange={(e) =>
								onChangeValue(
									'height',
									e.target.value,
									fieldChange.signature,
									null,
									null,
								)
							}
						/>
					</div>
				</div>
				<div className='d-flex flex-row justify-content-around'>
					<div className='form-group mt-2 w-100 mx-1'>
						<label>فاصله از بالا</label>
						<input
							className='form-control my-2'
							onChange={(e) =>
								onChangeValue(
									'image_top',
									e.target.value,
									fieldChange.signature,
									null,
									null,
								)
							}
						/>
					</div>
					<div className='form-group mt-2 w-100 mx-1'>
						<label>فاصله از راست</label>
						<input
							className='form-control my-2'
							onChange={(e) =>
								onChangeValue(
									'image_right',
									e.target.value,
									fieldChange.signature,
									null,
									null,
								)
							}
						/>
					</div>
					<div className='form-group mt-2 w-100 mx-1'>
						<label>فاصله از چپ</label>
						<input
							className='form-control my-2'
							onChange={(e) =>
								onChangeValue(
									'image_left',
									e.target.value,
									fieldChange.signature,
									null,
									null,
								)
							}
						/>
					</div>
					<div className='form-group mt-2 w-100 mx-1'>
						<label>فاصله از پایین</label>
						<input
							className='form-control my-2'
							onChange={(e) =>
								onChangeValue(
									'image_bottom',
									e.target.value,
									fieldChange.signature,
									null,
									null,
								)
							}
						/>
					</div>
				</div>
				<div className='d-flex flex-row justify-content-around'>
					<div className='form-group mt-2 w-100 mx-1'>
						<label>فاصله عنوان از بالا</label>
						<input
							className='form-control my-2'
							onChange={(e) =>
								onChangeValue(
									'title_top',
									e.target.value,
									fieldChange.signature,
									null,
									null,
								)
							}
						/>
					</div>
					<div className='form-group mt-2 w-100 mx-1'>
						<label>فاصله عنوان از راست</label>
						<input
							className='form-control my-2'
							onChange={(e) =>
								onChangeValue(
									'title_right',
									e.target.value,
									fieldChange.signature,
									null,
									null,
								)
							}
						/>
					</div>
					<div className='form-group mt-2 w-100 mx-1'>
						<label>فاصله عنوان از چپ</label>
						<input
							className='form-control my-2'
							onChange={(e) =>
								onChangeValue(
									'title_left',
									e.target.value,
									fieldChange.signature,
									null,
									null,
								)
							}
						/>
					</div>
					<div className='form-group mt-2 w-100 mx-1'>
						<label>فاصله عنوان از پایین</label>
						<input
							className='form-control my-2'
							onChange={(e) =>
								onChangeValue(
									'title_bottom',
									e.target.value,
									fieldChange.signature,
									null,
									null,
								)
							}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SignatureFields;
